// extracted by mini-css-extract-plugin
export default {"wrapper":"JV-z"};